import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import Logo from "@/components/Logo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/customer/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Request failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-80px)] grid place-items-center px-6 py-16" data-testid="forgot-page">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center text-center">
          <Logo variant="monogram" className="h-14 w-14 dark:invert" loading="eager" />
        </div>
        <h1 className="mt-10 text-4xl font-serif tracking-tighter text-center">Reset your password</h1>
        <p className="mt-3 text-sm opacity-60 text-center">
          Enter your email and we'll send you a link to reset it.
        </p>

        {sent ? (
          <div className="mt-10 border p-6 text-center" data-testid="forgot-success">
            <p className="font-serif text-xl">Check your inbox.</p>
            <p className="mt-3 text-sm opacity-70">
              If an account exists for <span className="text-foreground">{email}</span>, you'll receive an email
              shortly. The link expires in 1 hour.
            </p>
            <Link to="/login" className="inline-block mt-8 label-xs link-underline">
              Back to sign in
            </Link>
          </div>
        ) : (
          <>
            <form onSubmit={submit} className="mt-10 space-y-4">
              <div>
                <Label className="label-xs">Email</Label>
                <Input
                  required
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="rounded-none mt-2"
                  data-testid="forgot-email"
                />
              </div>
              <Button
                type="submit"
                disabled={busy}
                className="w-full h-12 rounded-none label-xs"
                data-testid="forgot-submit"
              >
                {busy ? "Sending…" : "Send Reset Link"}
              </Button>
            </form>
            <p className="mt-6 text-sm text-center opacity-80">
              <Link to="/login" className="link-underline" data-testid="forgot-back-link">
                Back to sign in
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
